import pipe from 'lodash/fp/pipe';
import toLower from 'lodash/fp/toLower';
import replace from 'lodash/fp/replace';

export default pipe(replace('CHARCOAL', 'neutral-darkest'), toLower);
